
require("./../../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import { useEffect } from 'react';
import { Request } from 'express';
import debounce from 'lodash/debounce';

import { Article } from 'editorial/components/Article';
import { IArticle } from 'editorial/types';
import { sendTrackingEvent } from 'tracking/utils/sendTrackingEvent';
import { useMParticleContext } from 'tracking/hooks/useMParticleContext';
import { cmsRequest } from 'server/services/cms-service/cmsRequest';
import { setServerSideTranslations } from 'localization/utils/setServerSideTranslations';
import { getRedirectionPath } from 'localization/utils/getRedirectionPath';
import { LOCALES } from 'localization/constants/configEnums';

export const EditorialArticle = ({ article, nextArticle }) => {
  const { isMParticleReady } = useMParticleContext();

  useEffect(() => {
    if (isMParticleReady) {
      sendTrackingEvent('ARTICLE_VIEW');
    }
  }, [isMParticleReady]);

  const handleScroll = debounce(() => {
    sendTrackingEvent('ARTICLE_USER_SCROLL');
  }, 50);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return <Article article={article} nextArticle={nextArticle} />;
};

export const getServerSideProps = async (ctx) => {
  const {
    req,
    query: { slug },
    locale,
  }: {
    req: Request;
    query: { slug: string };
    locale: string;
  } = ctx;
  let nextArticle = null;

  if (locale === LOCALES.frFR) {
    return { notFound: true };
  }

  try {
    const data = cmsRequest(req).get(`api/v1/cms/cms_articles/${slug}`);
    const article: IArticle = await data.json();

    if (article?.category) {
      const nextArticleData = cmsRequest(req).get(
        `api/v1/cms/cms_articles/${slug}/next?category=${article.category}`,
      );
      nextArticle = await nextArticleData.json();
    }

    return {
      props: {
        ...(await setServerSideTranslations({ locale })),
        article,
        nextArticle,
      },
    };
  } catch {
    return {
      redirect: {
        destination: getRedirectionPath('/editorial', locale),
        permanent: false,
      },
    };
  }
};

export default EditorialArticle;
